import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { map } from 'rxjs/operators';
import { AppEventsService, AuthRedirectEffect, PAGE_TITLE_AREAS, PageTitleService } from 'lib-klab-core';
import { WORKSPACE_AREA_CONFIG } from './modules/home/workspace-area.config';
import { LoaderComponent } from './modules/shared/loader/components/loader/loader.component';
import { CoreUIFlashToastModule, CoreUIToastsV2Module } from 'lib-klab-core-ui';

@Component({
  selector: 'app-root',
  providers: [{ provide: PAGE_TITLE_AREAS, useValue: Object.fromEntries(
    Object.entries(WORKSPACE_AREA_CONFIG).map(([key, area]) => [key, key === 'staff' ? 'KlabStaff' : key === 'klab-time' ? 'KlabTime' : area.contextTitle]),
  ) }, PageTitleService],
  imports: [RouterOutlet, LoaderComponent, CoreUIToastsV2Module, CoreUIFlashToastModule, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly appEvents = inject(AppEventsService);
  private readonly _authRedirectEffect = inject(AuthRedirectEffect);
  private readonly pageTitle = inject(PageTitleService);

  readonly loaderApp$ = this.appEvents.loader().pipe(
    map((v: any) => Boolean(v?.visible)),
  );
}
